import { render, staticRenderFns } from "./SnippetBox.vue?vue&type=template&id=95c729b8&scoped=true&"
import script from "./SnippetBox.vue?vue&type=script&lang=js&"
export * from "./SnippetBox.vue?vue&type=script&lang=js&"
import style0 from "./SnippetBox.vue?vue&type=style&index=0&id=95c729b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c729b8",
  null
  
)

export default component.exports